import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './sections/Header';
import { Hero } from './sections/Hero';
import { About } from './sections/About';
import { Services } from './sections/Services';
import { WhyChooseUs } from './sections/WhyChooseUs';
import { FundingPromo } from './sections/FundingPromo';
import { Team } from './sections/Team';
import { Testimonials } from './sections/Testimonials';
import { Contact } from './sections/Contact';
import { Footer } from './sections/Footer';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { MarketMarketingResearch } from './pages/MarketMarketingResearch';
import { FinanceTaxAccounting } from './pages/FinanceTaxAccounting';
import { BusinessProposalPitchDeck } from './pages/BusinessProposalPitchDeck';
import { BusinessAdvisory } from './pages/BusinessAdvisory';
import { Funding } from './pages/Funding';
import { BusinessITService } from './pages/BusinessITService';
import { BusinessStrategyAudit } from './pages/BusinessStrategyAudit';
import { HumanResourcePlanningTraining } from './pages/HumanResourcePlanningTraining';
import { IndustryEconomicAnalysis } from './pages/IndustryEconomicAnalysis';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  
  return null;
}

function HomePage() {
  useEffect(() => {
    // Smooth scroll behavior for anchor links
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (anchor) {
        e.preventDefault();
        const href = anchor.getAttribute('href');
        if (href && href !== '#') {
          const element = document.querySelector(href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <main>
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <FundingPromo />
      <Team />
      <Testimonials />
      <Contact />
    </main>
  );
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white overflow-x-hidden">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/produk-layanan" element={<Products />} />
          <Route path="/produk-layanan/market-marketing-research" element={<MarketMarketingResearch />} />
          <Route path="/produk-layanan/finance-tax-accounting" element={<FinanceTaxAccounting />} />
          <Route path="/produk-layanan/business-proposal-pitch-deck" element={<BusinessProposalPitchDeck />} />
          <Route path="/produk-layanan/business-advisory" element={<BusinessAdvisory />} />
          <Route path="/produk-layanan/business-it-service" element={<BusinessITService />} />
          <Route path="/produk-layanan/business-strategy-audit" element={<BusinessStrategyAudit />} />
          <Route path="/produk-layanan/human-resource-planning-training" element={<HumanResourcePlanningTraining />} />
          <Route path="/produk-layanan/industry-economic-analysis" element={<IndustryEconomicAnalysis />} />
          <Route path="/pendanaan-bisnis" element={<Funding />} />
          <Route path="/produk-layanan/:id" element={<ProductDetail />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;